<template>
  <div class="relative">
    <el-input
      v-model="valueBackup"
      :placeholder="placeholderBackup"
      :disabled="true"
    />
    <div class="absolute list">
      <div v-for="v in list" :key="v.id" :class="`card${valueBackup === v.id ? ' checked' : ''}`" @click="handleClick(v)">
        <div class="title">
          <span class="card-id">No.{{v.id}}</span>
        </div>
        <div class="card-content">
          课券名称：「<span class="success-color">{{ v.card_ticket_type_name }}</span>」；
          归属门店：「<span :class="{ 'info-color': !v.store_id }">{{ v.store_name }}</span>」；
          <span v-if="v.is_app && !v.store_id" class="primary-color">签到/爽约后自动归属到当前门店</span>
          <span v-else-if="v.store_source_name" class="info-color">（{{ v.store_source_name }}）</span>
          办理时间：「{{ v.add_time | timeToYmd }}」
        </div>

        <div class="card-content">
          失效时间：「<span v-if="v.expire_time">{{ v.expire_time | timeToYmdHi }}</span><span v-else class="primary-color bolder">未开券</span>」；
          剩余次数：「<span class="success-color">{{ v.expire_number | toYuan }}</span> 次」；
          有效天数：「{{ v.expire_days | toYuan }} 天」；
        </div>

        <div class="card-content">
          实际付款：「{{ v.actual_payment | toYuan }} 元」；
          付款方式：「{{ v.card_payment_mode_name }}」
        </div>

        <div class="card-content">
          付款备注：「{{ v.payment_remark }}」；
          课消：「{{ v.unit_price | toYuan }} 元」；
          <template v-if="v.you_zan_number">
            ；有赞券码：「{{ v.you_zan_number }}」
          </template>
        </div>
      </div>
      <div v-if="count" class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { index } from '@/api/card-ticket';
import { cardTicketStates } from "@/enums/cardTicketStates";

export default {
  props: {
    value: [Number, String],
    studentId: [Number, String],
    placeholder: String,
    width: {
      type: String,
      default: '100%',
    },
  },
  data: () => ({
    valueBackup: '',
    placeholderBackup: '',
    inputValue: '',
    list: [],
    count: 0,
    page: 1,
    size: 3,
    pageSizes: [3],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
    studentId(studentId) {
      if (studentId) {
        this.getList(studentId);
      } else {
        this.list = [];
        this.count = 0;
        this.placeholderBackup = this.placeholder || '请选择学员后再选择课卡';
      }
    },
    list(list) {
      this.$emit('listLengthChange', list ? (list.length || 0) : 0);
    },
    cardTicketTypeId() {
      this.valueBackup = '';
      this.getList(this.studentId);
    },
  },
  methods: {
    async getList(student_id) {
      if (!student_id) return;

      const { isError, data } = await index({
        student_ids: [student_id],
        card_ticket_states: [cardTicketStates.usable.value],
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
      this.placeholderBackup = '请选择课次券';
      this.$nextTick(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        });
      });
    },
    handleClick(card) {
      if (!card.id) return;
      if (card.id === this.valueBackup) return;

      this.valueBackup = card.id;
      this.$emit('change', card);
    },
    handlePageChange() {
      this.getList(this.studentId);
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.placeholderBackup = this.placeholder || '请选择学员后再选择课次券';
    this.getList(this.studentId);
  },
};
</script>

<style src="./index.css" scoped/>
